import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { PedidoDetalle } from './PedidoDetalle';
import { PedidoEntidad } from './PedidoEntidad';
import { Pedidos } from './pedidos';

@Injectable({
  providedIn: 'root'
})
export class PedidosService {

  constructor(private http: HttpClient) { }

  getPedidos(fecha: string,id: string) {  
    
    return this.http.get<Pedidos[]>(environment.apiUrl+"/listarVPedidos/?fecha=" + fecha+"&idEmisor="+id);  
  }  

  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarPedido/?id="+id);
  }

  setActulizar(pedidos: PedidoEntidad[]){
    console.log(pedidos);
    return this.http.put<string>(environment.apiUrl+"/actualizarPedido",pedidos);
  }
  buscarPedido(id: number) {  
    
    return this.http.get<PedidoEntidad>(environment.apiUrl+"/buscarPedido/?id="+id);  
  }  
  buscarPedidoDetalle(id: number) {  
    
    return this.http.get<PedidoDetalle[]>(environment.apiUrl+"/buscarPedidoDetalle/?id="+id);  
  }  



}
